import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/cross-border-processing")({
  beforeLoad: () => {
    throw redirect({ to: "/privacy", hash: "cross-border" });
  },
});
